import { AccionesContenedor, Contenedor, ContenidoContenedor, FiltrosContenedor, TituloContenedor } from 'componentes/ui/contenedores'
import { useLocalization } from 'contexto/localization/useLocalization';
import useRoles from 'hooks/useRoles';
import React, { useState } from 'react'
import ListaPaginadaPagos from './components/ListaPaginadaPagos';
import PromisePagSelect from 'componentes/PromisePagSelect';
import useListaContratosPaginada from './components/ListaPaginadaPagos/hooks/useListaContratosPaginada';
import useQueryParam from 'hooks/useQueryParam';
import { BotonNuevo } from 'componentes/ui/botones';
import ModalCrearEditarPago from './components/ModalCrearEditarPago';

const PaginadorPagosContrato = () => {
    // Idioma
    const { strings } = useLocalization();
    // Token
    const [roles] = useRoles();
    // Estados
    const tableRef = React.useRef();
    const [openModalNuevo, setOpenModalNuevo] = useState(false);
    //Parametros URL
    const [contratoSelecc, setContratoSelecc] = useQueryParam('cn', 'todo');
    //Paginador

    //Listas
    const { obtenerListaContratos } = useListaContratosPaginada();

    return (
        <Contenedor maxWidth='lg'>
            <TituloContenedor titulo={strings.modules.pagosContrato} />
            <FiltrosContenedor>
                <PromisePagSelect
                    label={strings.modules.contrato}
                    size='small'
                    onChange={(v) => setContratoSelecc(v.target.value.toString())}
                    onLoadOptions={(v) => setContratoSelecc(v !== undefined ? v.value : '0')}
                    loadOptions={obtenerListaContratos}
                    value={contratoSelecc}
                    defaultValue={contratoSelecc}
                />
            </FiltrosContenedor>
            <AccionesContenedor>
                <BotonNuevo
                    onClick={() => setOpenModalNuevo(true)}
                    disabled={openModalNuevo}
                    hidden={roles.includes("Lector")}
                />
            </AccionesContenedor>
            <ContenidoContenedor>
                <ListaPaginadaPagos ref={tableRef} />
                {openModalNuevo && (
                    <ModalCrearEditarPago
                        tipoAccion='crear'
                        open={openModalNuevo}
                        onClose={() => setOpenModalNuevo(false)}
                        onSave={() => {
                            tableRef.current.onQueryChange();
                            setOpenModalNuevo(false);
                        }}
                    />
                )}
            </ContenidoContenedor>
        </Contenedor>
    )
}

export default PaginadorPagosContrato